import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation, useParams } from 'react-router-dom';

import storeRedirectActions from 'actions/store-redirect-actions';
import { buildSignInPath } from 'constants/route-paths';
import { useAuthenticated } from 'hooks/auth';

const StoreRedirect = () => {
  const location = useLocation();
  const history = useHistory();
  const { siteSlug } = useParams();
  const dispatch = useDispatch();
  const isAuthenticated = useAuthenticated();

  const redirectTo = useSelector((state) => get(state, 'redirectTo', {}));

  useEffect(() => {
    if (!isEmpty(redirectTo)) {
      const { status, redirectPath } = redirectTo;

      if (status === 401 && !isAuthenticated) {
        history.replace(buildSignInPath(siteSlug), { from: location });
      } else {
        history.push(redirectPath);
      }
    }

    return () => {
      dispatch(storeRedirectActions.clearRedirectPath());
    };
  }, [history, dispatch, location, redirectTo, siteSlug, isAuthenticated]);

  return null;
};

export default StoreRedirect;
